<template>
    <div class="map"></div>
</template>

<script>
import City from '@/util/City';
// import China from '@/util/China';
import '../../../util/China.js';

export default {
    data() {
        return {

        };
    },
    props: {
        provinces: {
            type: Array,
            default() {
                return {};
            }
        }
    },
    watch: {
        provinces: {
            handler() {
                this.getMap();
            },
            deep: true // 必须开启深度监听
        }
    },
    mounted() {
        this.getMap();
    },
    methods: {
        // 地图
        getMap() {
            // 地图的坐标信息
            const geoCoordMap = City;
            // 数据信息
            const SHData = this.provinces.filter(item => item.value > 0).map(item => [{
                name: '上海'
            },
            {
                name: item.name,
                value: item.value,
                areaArr: item.areaArr,
                visualMap: false
            }]);
            // const planePath = 'path://M.6,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705';
            // const planePath = 'path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z';
            const planePath = '';
            const convertData = function (data) {
                // data SHData
                const res = [];
                for (let i = 0; i < data.length; i++) {
                    // SHData
                    const dataItem = data[i];
                    const fromCoord = geoCoordMap[dataItem[0].name]; // 上海
                    const toCoord = geoCoordMap[dataItem[1].name];
                    if (fromCoord && toCoord) {
                        res.push([{
                            coord: fromCoord,
                            visualMap: false
                        }, {
                            coord: toCoord,
                            value: dataItem[1].value,
                            areaArr: dataItem[1].areaArr,
                            visualMap: false
                        }]);
                    }
                }
                return res;
            };
            const series = [];
            [
                ['上海', SHData]
            ].forEach((item) => {
                series.push(
                    /* {
                        // 设置飞机后的烟雾
                        type: 'lines',
                        zlevel: 1,
                        effect: {
                            show: true,
                            period: 6,
                            trailLength: 0.7,
                            color: 'white',
                            symbolSize: 3,
                            //symbol: planePath
                            symbol: "arrow" // 小箭头
                        },
                        // 线宽
                        lineStyle: {
                            normal: {
                                color: '#fff',
                                width: 0,
                                curveness: 0.2
                            }
                        },
                        data: convertData(item[1]) // 坐标
                    }, */
                    {
                        type: 'lines',
                        zlevel: 2,
                        silent: true,
                        effect: {
                            show: true,
                            period: 6,
                            trailLength: 0,
                            // symbol: planePath,
                            symbol: 'arrow', // 小箭头
                            symbolSize: 8
                        },
                        lineStyle: {
                            normal: {
                                color(params) {
                                    return '#f26419';
                                },
                                width: 2,
                                opacity: 0.4,
                                curveness: 0.5
                            }
                        },
                        data: convertData(item[1])
                    },
                    {
                    // 设置圆圈属性的
                        name: `${item[0]}`,
                        type: 'effectScatter',
                        coordinateSystem: 'geo',
                        // 鼠标移入显示的东西
                        tooltip: {
                            showDelay: 0,
                            formatter(params) {
                                const str = `${params.name}受助区域：${params.data.areaArr}`;
                                return str;
                            },
                            axisPointer: {
                                show: true,
                                type: 'cross',
                                lineStyle: {
                                    type: 'dashed',
                                    width: 1
                                }
                            }
                        },
                        zlevel: 2,
                        rippleEffect: {
                            brushType: 'stroke'
                        },
                        label: {
                            normal: {
                                show: true,
                                formatter: '{b}'
                            }
                        },
                        // 设置圆圈大小
                        symbolSize(val) {
                            // val的值是data的值
                            return 12;
                        },
                        itemStyle: {
                            normal: {
                                color(params) {
                                // console.log(params);
                                    if (params.data.areaArr !== '' && params.data.areaArr) {
                                        return '#ED7119';
                                    }
                                    return '#FFB47F';
                                }
                            }
                        },
                        data: item[1].map(dataItem => ({
                            name: dataItem[1].name,
                            value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value]),
                            areaArr: dataItem[1].areaArr,
                            visualMap: false
                        }))
                    }, {
                        type: 'map',
                        mapType: 'china',
                        label: {
                            normal: {
                                show: false,
                                color: '#fff'
                            },
                            emphasis: {
                                show: true,
                                color: '#fff'
                            }
                        },
                        roam: false,
                        tooltip: {
                            showDelay: 0,
                            formatter(params) {
                                // console.log(params);
                                let str = '';
                                if (params.data) {
                                    str = `${params.name}受助区域：${params.data.areaArr}`;
                                }
                                return str;
                            }
                        },
                        itemStyle: {
                            normal: {
                                // 设置区域颜色
                                areaColor: 'rgba(255, 180, 127, 1)',
                                // 设置边框
                                borderWidth: 1,
                                borderColor: '#ffffff',
                                show: true,
                                formatter: '{b}'
                            },
                            emphasis: {
                                // 设置鼠标悬停时候的样式
                                areaColor: '#ED7119'
                            }
                        },
                        data: item[1].map(dataItem => ({
                            name: dataItem[1].name,
                            value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value]),
                            areaArr: dataItem[1].areaArr,
                            visualMap: false
                        }))
                    }
                );
            });
            /* series[2].itemStyle = {
            	normal: {
            		areaColor: '#FFB47F'
            	}
            }; */
            // console.log(series);
            const option = {
                // 设置为半透明
                backgroundColor: 'transparent',
                title: {
                    left: 'left',
                    textStyle: {
                        color: '#fff'
                    }
                },
                tooltip: {
                    trigger: 'item'
                },
                series,
                // 设置地图默认大小
                geo: {
                    map: 'china',
                    label: {
                        normal: {
                            show: false,
                            color: '#fff'
                        },
                        emphasis: {
                            show: true,
                            color: '#fff'
                        }
                    },
                    roam: false,
                    itemStyle: {
                        normal: {
                            // 设置区域颜色
                            areaColor: 'rgba(255, 180, 127, 1)',
                            // 设置边框颜色
                            borderColor: '#ffffff'
                        },
                        emphasis: {
                            // 设置鼠标悬停时候的样式
                            areaColor: '#ED7119'
                        }
                    }
                },
                visualMap: { // dataRange设置
                    textStyle: { color: '#000' },
                    x: '200',
                    y: '650',
                    type: 'piecewise',
                    seriesIndex: [2],
                    splitNumber: 2, // 对于连续型数据，自动平均切分成几段。默认为5段
                    pieces: [
                        { min: 10, max: 200, label: '已受助区域', color: '#FFC90E' },
                        { max: 10, label: '未受助区域', color: '#FFB47F' } // 不指定 min，表示 min 为无限大（-Infinity）。
                    ]
                    /* inRange: {
                        // 渐变颜色，从小到大
                        color: ['#ED7119', '#FFB47F']
                    } */

                    // color: ['#FFB47F', '#ED7119']
                }

            };
            this.$echarts.init(document.querySelector('.map')).setOption(option);
        }
    }
};
</script>

<style>
    .map{
        width: 1180px;
        height: 813px;
    }
</style>



// WEBPACK FOOTER //
// src/page/home/components/home-map.vue